import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '../'
import Icon from '../Icon'
import * as styles from './PasswordField.scss'

export default class PasswordField extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }

  state = {
    showPassword: false,
  }

  constructor(props) {
    super(props)
    this.state = { [this.props.name]: '' }
  }

  togglePasswordField = () => {
    this.setState(state => {
      return { showPassword: !state.showPassword }
    })
  }
  // TODO: make an proper password field ;)
  render() {
    const { showPassword } = this.state
    return (
      <div>
        <div className={styles.passwordFieldContainer}>
          <TextField
            {...this.props}
            floatIcon={<Icon source={showPassword ? 'eyeOff' : 'eye'} />}
            floatIconClick={this.togglePasswordField}
            type={showPassword ? 'text' : 'password'}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PasswordField/index.js